import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dyeing',
  templateUrl: './dyeing.component.html',
  styleUrls: ['./dyeing.component.css']
})
export class DyeingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
